const networks = [
  {
    code: "N.01",
    name: "Amze Network",
    role: "The Hunters",
    body: "Chase the target through signals, sources and evidence chains.",
    color: "#dc2626",
  },
  {
    code: "N.02",
    name: "Allam Network",
    role: "The Protectors",
    body: "Shield the legendary prospect. Verify every claim. Trust nothing.",
    color: "#f59e0b",
  },
  {
    code: "N.03",
    name: "D. Saab Network",
    role: "The Manipulators",
    body: "Bend the truth. Plant shadows. Test the room's resistance to deception.",
    color: "#a855f7",
  },
  {
    code: "N.04",
    name: "Pathan Gang",
    role: "The Competitors",
    body: "Play parallel. Play sharper. Every network races for the same finish line.",
    color: "#22d3ee",
  },
];

const NET_IMG =
  "https://images.unsplash.com/photo-1643377667360-c2be0413ebcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxjaGVzcyUyMGdhbWUlMjBkYXJrJTIwY2luZW1hdGljfGVufDB8fHx8MTc4Mjg4NzUwOHww&ixlib=rb-4.1.0&q=85";

export default function Networks() {
  return (
    <section
      id="networks"
      data-testid="networks-section"
      className="relative py-28 lg:py-36 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 lg:col-span-7">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#dc2626]" /> 05 · The Hunt for Allam
            </div>
            <h2 className="font-display uppercase font-black text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Four networks.
              <br />
              <span className="text-neutral-500">One legendary</span> prospect.
            </h2>
            <p className="mt-6 text-neutral-400 leading-relaxed max-w-xl">
              Shadow Allams. Fake evidence chains. Six critical links from{" "}
              <span className="text-white">Signal → Source → Verification → Evidence →
              Decision → Allam</span>. Is your target real, or a construct?
            </p>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <div className="relative aspect-[4/3] border border-white/10 overflow-hidden">
              <img src={NET_IMG} alt="" className="w-full h-full object-cover opacity-70" />
              <div className="absolute inset-0 scanlines" />
              <div className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#dc2626]">
                ● LIVE FEED · SECTOR 7
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {networks.map((n, i) => (
            <div
              key={i}
              data-testid={`network-card-${i}`}
              className="group relative bg-[#0a0a0a] border border-white/10 p-6 min-h-[240px] flex flex-col justify-between hover:-translate-y-1 transition-all"
              style={{ borderTopWidth: "2px", borderTopColor: n.color }}
            >
              <div>
                <div
                  className="font-mono text-[10px] uppercase tracking-[0.25em] mb-4"
                  style={{ color: n.color }}
                >
                  {n.code} · {n.role}
                </div>
                <h3 className="font-display uppercase font-black text-2xl tracking-tight leading-tight">
                  {n.name}
                </h3>
                <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{n.body}</p>
              </div>
              <div className="mt-6 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
                <span>PROFILE</span>
                <span className="group-hover:text-white transition-colors">→</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
